import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Viewer } from '../../../widgets/Viewer';
import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog, Button, MenuItem } from '@blueprintjs/core';
import { Select } from "@blueprintjs/select";

import { filterRecipients } from '../../../../helpers/functions';
import { saveDonation } from '../../../../redux/actions/donation.actions';

const mapStateToProps = (state) => ({
    general: state.general,
    donation: state.donation,
    recipient: state.recipient
});

class AddDonationModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            amount: '',
            donation_date: new Date(),
            notes: '',
            recipient_id: null,
            filename: '',
            dropbox_image_share_url: '',
            image: '',
            currency: 'CAD'
        };
        this.state = {
            showModal: false,
            filterValue: '',
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-add-donation-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-add-donation-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { donation: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, file, value }) => {
        const { form } = this.state;

        // Extract last file
        if (file && file[0]) {
            const reader = new FileReader();
            const lastFile = file[0];
            reader.readAsDataURL(lastFile);
            reader.onloadend = () => {
                form.image = reader.result;
                this.setState({ form });
            }
            form.filename = lastFile.name;
        }

        if (text !== undefined) {
            form[value] = text;
        }
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13 && this.isFormInputValid()) {
            this.saveDonation();
        }
    }
    saveDonation = () => {
        const newForm = { ...this.state.form };
        if (newForm.image) {
            newForm.image = newForm.image.split(',')[1];
        }
        newForm.amount = newForm.amount ? parseFloat(newForm.amount).toFixed(2) : 0;
        this.props.saveDonation(newForm);
    }
    recipientItemRenderer = (item, {index, handleClick}) => {
        const isSelected = this.state.recipient_id === item.id;
        return (
            <MenuItem
                icon={isSelected ? 'tick' : 'blank'}
                key={index}
                label={`${item.gender} | ${item.country_of_school} | ${item.city_of_school}`}
                onClick={handleClick}
                text={`${item.first_name} ${item.middle_name} ${item.last_name}`}
            />
        );
    }
    onRecipientSelect = (item) => {
        const newForm = this.state.form;
        newForm.recipient_id = parseInt(item.id, 10);
        this.setState({ form: newForm });
    }
    handleFilterChange = (event) => {
        this.setState({ filterValue: event.target.value });
    }

    isFormInputValid = () => {
        const newForm = { ...this.state.form };
        return newForm.amount ? true : false;
    }

    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.donation;
        const { recipients, recipientsById } = this.props.recipient;
        const selectedRecipient = this.state.form.recipient_id ? recipientsById[this.state.form.recipient_id] : null;
        const { supportedCurrencies } = this.props.general;
        let currencies = Object.keys(supportedCurrencies);

        return (
            <Dialog icon='dollar'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                canOutsideClickClose={false}
                title="Add Student Donation">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="Amount (required)"
                                    name="amount"
                                    value={form.amount}
                                    type="numeric"
                                    onChangeHandler={this.onChangeHandler}
                                />
                                <RenderInput label="Currency"
                                    name="currency"
                                    value={form.currency}
                                    type="select"
                                    items={currencies}
                                    onChangeHandler={this.onChangeHandler}
                                />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Donation Date"
                                    name="donation_date"
                                    value={form.donation_date}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler}
                                />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Donation Notes"
                                    name="notes"
                                    value={form.notes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler}
                                />
                            </div>
                            <div className="flex-row" style={{ marginBottom: 15 }}>
                                <Select
                                    items={recipients}
                                    filterable
                                    itemRenderer={this.recipientItemRenderer}
                                    itemPredicate={filterRecipients}
                                    onItemSelect={this.onRecipientSelect}
                                    popoverProps={{ usePortal: false, minimal: true }}
                                    inputProps={{ value: this.state.filterValue, onChange: this.handleFilterChange }}
                                    noResults={<MenuItem disabled={true} text="No results." />} >
                                    <Button text={selectedRecipient ?
                                        `${selectedRecipient.first_name} ${selectedRecipient.middle_name} ${selectedRecipient.last_name} (${selectedRecipient.gender} | ${selectedRecipient.country_of_school} | ${selectedRecipient.city_of_school})`
                                        : 'Select a Recipient (Optional)'
                                    }
                                        rightIcon="double-caret-vertical" 
                                />
                                </Select>
                            </div>
                            <div className="flex-row">
                                <RenderInput name="filename"
                                    type="upload"
                                    value={form.filename}
                                    onChangeHandler={this.onChangeHandler}
                                />
                            </div>
                            <div className="flex-row">
                                { form.image || form.dropbox_image_share_url ?
                                     <div className="flex-column">
                                        <Viewer src={form.image || form.dropbox_image_share_url || ''} style={{ width: '100%' }} />
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton
                                    className="pt-button pt-fill pt-intent-primary pt-large"
                                    text="Save Donation"
                                    onClick={this.saveDonation}
                                    isLoading={saveLoading}
                                    disabled={!this.isFormInputValid()}
                                />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveDonation }
)(AddDonationModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/DonationModal.jsx